import { bumiOnboardingABTestRouteConfig } from '@/config/abTestConfig'
import { saveAnswer } from '@/utils/onboardingStorage'
import {
  getRouteConfigForVariant,
  navigateToNextOnboardingPage,
} from '@app-studio-web/ui/helpers/abTestRouting'
import { trackOnboardingFormData } from '@app-studio-web/ui/helpers/snowplowTracking'
import { getABTestVariantFromContext } from '@app-studio-web/ui/helpers/variantContext'

function normalizeValue(value: FormDataEntryValue) {
  return String(value)
}

export default async function navigateToNextOnboardingPageAction({
  request,
}: {
  request: Request
}) {
  const formData = await request.formData()
  const entries = Array.from(formData.entries())

  if (entries.length > 0) {
    const [question, firstValue] = entries[0]
    const values = formData.getAll(question).map(normalizeValue)
    const answerValue =
      values.length > 1 ? values.join(', ') : normalizeValue(firstValue)
    const path =
      new URL(request.url).pathname.split('/').filter(Boolean).pop() || 'root'

    saveAnswer(path, {
      question_key: path,
      question: question || path,
      answer_key: values[0] || answerValue,
      answer: answerValue,
    })

    // The gender question lives at /welcome (ad landing path); store the
    // answer under 'gender' too, which is what the rest of the app reads.
    if (path === 'welcome') {
      saveAnswer('gender', {
        question_key: 'gender',
        question: 'gender',
        answer_key: values[0] || answerValue,
        answer: answerValue,
      })
    }
    if (path === 'name') {
      saveAnswer('name', {
        question_key: 'name',
        question: 'name',
        answer_key: answerValue,
        answer: answerValue,
      })
    }
    if (path === 'personality') {
      saveAnswer('personality', {
        question_key: 'personality',
        question: 'personality',
        answer_key: values[0] || answerValue,
        answer: answerValue,
      })
    }
  }

  const variant = getABTestVariantFromContext()

  trackOnboardingFormData({
    formData,
    url: request.url,
    orderedRoutes: getRouteConfigForVariant(
      variant,
      bumiOnboardingABTestRouteConfig,
    ),
  })

  return navigateToNextOnboardingPage({
    request,
    routeConfig: bumiOnboardingABTestRouteConfig,
    variant,
    redirectOnComplete: '/sign-up/company',
  })
}
